import { render, staticRenderFns } from "./ListCase.vue?vue&type=template&id=0b85c4e0&scoped=true"
import script from "./ListCase.vue?vue&type=script&lang=js"
export * from "./ListCase.vue?vue&type=script&lang=js"
import style0 from "./ListCase.vue?vue&type=style&index=0&id=0b85c4e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85c4e0",
  null
  
)

export default component.exports